module.exports = __webpack_public_path__ + "img/c3.dfbc4092.png";